import {
    chakra, Button
} from '@chakra-ui/react';

import { rippleButtonStyles } from './hooks/use-ripple-effect-click';

export const RippleButtonStyles = chakra(Button, {
    baseStyle: (props) => rippleButtonStyles(
        // any used as it's not clear how to type StyleResolverProps
        props as any
    )
});
